<template>
    <a class="head-cart" href="/personal/cart/" >
        <template v-if="!cartItems.length && cartItemsDelay.length">
            <div class="hc-ico" :data-count="cartItemsDelay.length" >
                <img src="/local/templates/lw/img/ico-cart.svg"/>
            </div>
        </template>
        <template v-else>
            <div class="hc-ico" :data-count="cartItems.length" >
                <img src="/local/templates/lw/img/ico-cart.svg"/>
            </div>
        </template>
        <div class="hc-info">
            <div class="hc-info__text">Корзина</div>
            <template v-if="!cartItems.length && cartItemsDelay.length">
                <div class="hc-info__price">{{ this.$store.state.cart.hasIndividualPrice ? $root.formatPrice(sum, 2) : sum }} руб</div>
            </template>
            <template v-else>
                <div v-if="cartItems.length" class="hc-info__price">{{ this.$store.state.cart.hasIndividualPrice ? $root.formatPrice(sum, 2) : sum }} руб</div>
                <div v-else class="hc-info__price">Корзина пуста</div>
            </template>
        </div>
    </a>
</template>

<script>
export default {
    name : 'Basketline',
	computed : {
		cartItems () {
			return this.$store.state.cart.items || [];
		},
		cartItemsDelay () {
            return this.$store.state.cart.itemsDelay || [];
		},
		sum () {
			return this.$store.state.cart.sum || 0;
		},
	},
}
</script>
